<template>
  <keep-alive>
    <transition name="slide-fade">
      <div>
        <FindBook :show="findBook" @on-back="() => (findBook = false)" />

        <div id="scrollBody" class="search-page">
          <div v-if="showSearchNav" class="search-nav">
            <div class="search-back" @click="backClear()">
              <img
                src="https://img.yzcdn.cn/upload_files/2020/03/24/FrCmwnSkYj5XwOuS4sLEcflSjMWB.png"
              />
            </div>
            <form action="javascript:return true" class="search" onsubmit="return false;">
              <input
                ref="input"
                v-model="search"
                type="search"
                placeholder="请输入书名、年级、科目查找书籍"
                autofocus="off"
                @keyup.13="searchWbIndex"
              />
            </form>
            <div class="search-button" @click="searchWbIndex">搜索</div>
          </div>
          <div class="search-content" :class="showSearchNav && 'have__header'">
            <div v-if="!initPage">
              <img
                v-if="btnFlag"
                class="srcollTop"
                src="https://img.yzcdn.cn/upload_files/2020/03/25/FipoLpm80QZ9eI8kwfXr0s6Q26Ba.png"
                @click="backTop()"
              />
              <ul>
                <li
                  v-for="(item, index) in searchData"
                  :key="index"
                  class="searchIndex"
                  @click="linkTo(item)"
                >
                  <div class="imgWrap">
                    <Book
                      :link-to="false"
                      :book-status="item"
                      :book-img="getImgUrl(item)"
                      :describe="false"
                    />
                  </div>
                  <div class="search-text">
                    <div class="title" v-text="item.joinName"></div>
                    <div class="des" v-text="item.describe"></div>
                  </div>
                </li>
              </ul>
              <!-- 列表结尾 -->
              <div v-if="searchData.length > 0" class="content-end">
                <p @click="scanQr">
                  <img
                    src="https://img.yzcdn.cn/upload_files/2020/03/25/FviHDijdlS1bFk5UYrrymOCf0j5W.png"
                  />没找到我要的书
                </p>
              </div>
              <div v-if="hasSearch" class="noContent flex-col flex-al-center">
                <img
                  src="https://img.yzcdn.cn/upload_files/2020/12/14/Fs5gnbVg4DYzz7UKvlHZ1nyJBeOS.png"
                  alt="ss"
                />
                <span>暂无相关搜索内容</span>
                <div class="apply flex-center" @click="scanQr">
                  {{ supportHolidayBook ? '扫码搜书' : '申请制作此书' }}
                </div>
              </div>
            </div>
            <!-- 初始化页面 -->
            <!-- <div v-if="initPage" class="init_page">
              <p class="init_title">扫描书后条形码找书更方便</p>
              <img
                class="init_img"
                src="https://img.yzcdn.cn/upload_files/2020/03/18/Fh1wuEqASmXnIaLLa6nQyLRqUVwB.png"
              />
              <p class="init_scan" @click="clickScanQRCode">去扫码</p>
            </div> -->
            <div v-if="initPage" class="sacn__find__book">
              <div class="center">
                <div class="header">
                  <div class="title">扫码搜书</div>
                  <div class="desc">扫描书后条形码，快速找到自己的书</div>
                </div>
                <div class="middle__image"></div>
                <div class="buttons">
                  <van-button
                    class="button"
                    round
                    color="linear-gradient(270deg, #FE3E42 2.36%, #FF715E 100%)"
                    @click="() => clickScanQRCode()"
                  >
                    扫码搜课本/练习册
                  </van-button>
                  <van-button
                    v-if="supportHolidayBook"
                    class="button hjzy"
                    round
                    color="linear-gradient(270deg, #4893FF 2.36%, #79B9FF 100%)"
                    @click="() => clickScanQRCode('hjzy')"
                  >
                    扫码搜假期作业
                  </van-button>
                  <div v-if="supportHolidayBook" class="danger">*假期作业仅支持扫码搜索</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </keep-alive>
</template>
<script>
import Book from '../../component/book'
import { Button as VanButton, Toast } from 'vant'
import FindBook from '../../component/findBook'
import { mapGetters } from 'vuex'
import { setScrollTop } from '@/static/js/style/scroll'
import { getJoinName } from '@/static/js/business'
import { getzdChildV2 } from '@/api/dictionary'
import { getHolidayHomeWorkList } from '@/api/holiday'
import { scanBookQRCode, toSearchResultPage } from '../../plugin/holiday'

export default {
  name: 'Search',
  components: {
    Book,
    [Toast.name]: Toast,
    FindBook,
    VanButton
  },
  data() {
    return {
      zidian: [], // 字典
      search: '',
      searchData: [],
      hasSearch: false,
      initPage: true,
      positionFlag: false,
      btnFlag: false,
      scrollTop: 0,
      timer: null,
      searchPage: true,
      isFindBook: false,
      findBook: false,
      scanResult: ''
    }
  },
  computed: {
    ...mapGetters(['openid', 'appid', 'supportHolidayBook']),
    showSearchNav() {
      return !this.$route.query.noHeader
    }
  },
  created() {
    this.getzdChildV2()
    this.$store.dispatch('holidayBook/dispatch_getCurrentHoliday')
  },
  methods: {
    // 获取字典
    async getzdChildV2() {
      const res = await getzdChildV2([
        { parentId: 'answercard.basicbook.course', recursiveTimes: 1 },
        { parentId: 'answercard.basicbook.grade', recursiveTimes: 1 }
      ])
      this.zidian = {
        grade: res.data.data['answercard.basicbook.grade'],
        course: res.data.data['answercard.basicbook.course']
      }
    },
    effectiveFilter(cate) {
      return [1, 9].indexOf(Number(cate)) > -1
    },
    scanQr() {
      this.supportHolidayBook ? this.scanQrSearch() : this.handleFindBook()
    },
    // 扫码求书
    handleFindBook() {
      this.$router.push('/findBook/findScanQr')
      // this.findBook = true
    },
    scanQrSearch() {
      this.$router.replace({ path: '/search', query: { answer: 1, noHeader: 1 } })
      this.searchData = []
      this.hasSearch = false
      this.initPage = true
    },
    toApply(type) {
      // if (type === 'textbook') {
      //   window.location.href = '/cms/weixin/hw/toAddNewBook'
      // }
      this.$router.push({ path: '/findBook/index' })
    },

    // 获取图片
    getImgUrl(item) {
      if (item.source_type === 'basic') {
        return this.$env.ossUrl(item.thumb_cover_path)
      } else {
        return '/cms' + item.thumb_cover_path
      }
    },
    // 返回顶部
    backTop() {
      const back = setInterval(() => {
        if (document.getElementById('scrollBody').scrollTop) {
          document.getElementById('scrollBody').scrollTop -= 50
        } else {
          clearInterval(back)
        }
      }, 16)
    },
    clickScanQRCode(type = 'textbook') {
      // return toSearchResultPage('9787111263867', 0, this.$route.query.answer, type)
      scanBookQRCode()
        .then((result) => {
          if (type === 'textbook') {
            toSearchResultPage(result, 0, this.$route.query.answer, type)
          } else if (type === 'hjzy') {
            const sn = result.split(',')[1] || ''
            this.dealISBN(sn, type, result)
          }
        })
        .catch((errMsg) => {
          this.$toast.fail(errMsg)
        })
    },
    // 处理ISBN
    async dealISBN(ISBN, type, fullSN) {
      // 检查isbn下是否有书
      const hasBookQuery = {
        sn: ISBN,
        appid: this.appid
      }
      const hasBookResult = await getHolidayHomeWorkList(hasBookQuery)
      if (hasBookResult.data && hasBookResult.data.length) {
        return this.$router.push({
          path: '/holidayBook/homeWork',
          query: { ...hasBookQuery, type: 'findBook' }
        })
      } else {
        toSearchResultPage(fullSN, 1, this.$route.query.answer, type)
      }
    },
    backClear() {
      this.initPage = true
      this.btnFlag = false
      this.search = ''
      this.back()
    },
    back() {
      this.$router.back()
    },
    linkTo(item) {
      window.location.href = this.$business.getBookHref({
        id: item.book_id,
        category: item.category
      })
    },
    searchWbIndex() {
      if (this.search) {
        Toast.loading({
          message: '数据加载中...',
          forbidClick: true,
          loadingType: 'spinner'
        })
        this.initPage = false
        this.$refs.input.blur()
        this.$http
          .get(
            `/mopa/api-answer-card/open/book/search?appid=${this.$store.appId}&searchField=${this.search}`
          )
          .then((res) => {
            if (res.data) {
              Toast.clear()
              this.searchData = res.data.data.map((item) => {
                return {
                  ...item,
                  joinName: getJoinName(item, this.zidian)
                }
              })
              if (this.searchData.length <= 0) {
                this.hasSearch = true
              } else {
                this.hasSearch = false
              }
              setScrollTop(document.querySelector('#scrollBody'), 0)
            }
          })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.noContent {
  img {
    margin-top: 48px;
    margin-right: 15px;
    width: 164px;
  }

  span {
    margin-top: 25px;
    font-size: 14px;
    line-height: 14px;
    color: #999999;
  }

  .apply {
    margin-top: 64px;
    width: 264px;
    height: 50px;
    border-radius: 50px;
    font-size: 18px;
    line-height: 20px;
    color: #ffffff;
    filter: drop-shadow(0px 4px 6px rgba(255, 97, 97, 0.15));
    background: linear-gradient(90deg, #fd735d 0.16%, #ff423c 100.16%);
  }
}

.sacn__find__book {
  height: 100%;
  display: flex;
  align-items: center;

  .center {
    margin-top: -1rem;
    width: 100%;
  }

  .buttons {
    margin-top: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 1rem;

    .button {
      width: 100%;

      &.hjzy {
        margin-top: 0.4rem;
        position: relative;

        &::after {
          position: absolute;
          content: '假期作业扫码入口';
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 14px;
          font-size: 10px;
          color: #ffffff;
          right: 0;
          top: 0;
          padding: 2px;
          background: #ffbf34;
          border-radius: 30px 50px 50px 15px;
        }
      }
    }
  }

  .header {
    margin-left: 0.77rem;
    position: relative;

    &::before {
      position: absolute;
      width: 2.09rem;
      height: 1.95rem;
      left: -16px;
      top: -40px;
      content: '';
      background: url(https://img01.yzcdn.cn/upload_files/2022/01/27/FoTP0sRSD9ZEzSXS74EEqGzpGeKM.png)
        no-repeat;
      background-size: contain;
    }
  }

  .title {
    font-weight: 600;
    font-size: 22px;
    line-height: 1.5;

    color: #333333;
  }

  .desc {
    font-size: 14px;
    line-height: 1.5;

    color: #666666;
  }

  .danger {
    margin-top: 9px;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height */
    width: 100%;
    color: #ff0000;
  }

  .middle__image {
    margin: 1.54rem auto 0;
    width: 6.13rem;
    height: 3.36rem;
    background: url('https://img01.yzcdn.cn/upload_files/2022/01/26/FhAehmZxsW8hl9EU_LA2BGZfahng.png')
      no-repeat;
    background-size: 100% 100%;
  }
}
</style>
<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100%);
  //   opacity: 0;
}

.search-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  overflow: auto;
  z-index: 999;

  .search-nav {
    position: fixed;
    z-index: 100;
    padding: 0.19rem 0rem;
    display: flex;
    align-items: center;
    height: 1.2rem;
    border-bottom: 1px solid #f4f4f4;
    background-color: #ffffff;
    left: 0;
    right: 0;

    .search-back {
      margin-left: 0.52rem;
      font-size: 0.37rem;
      font-weight: 400;
      //   color: white;
      img {
        width: 0.37rem;
        display: block;
      }
    }

    .search {
      background-color: #f4f4f4;
      border-radius: 0.47rem;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.37rem;
      width: 7.28rem;
      height: 0.93rem;

      .seach-input {
        text-align: center;
      }

      input[type='search'] {
        -webkit-appearance: none;
        // 也可以去除加上border: 0;之类的 根据设计图来
      }

      input::-webkit-search-cancel-button {
        -webkit-appearance: none;
        position: relative;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        background: url('https://img.yzcdn.cn/upload_files/2019/12/25/FpV933qA3e6yeb3LPtE-6U-rmEJA.png')
          no-repeat center;
        background-size: 100% 100%;
      }

      input[type='search']::-ms-clear {
        color: transparent;
        position: relative;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        background: url('https://img.yzcdn.cn/upload_files/2019/12/25/FpV933qA3e6yeb3LPtE-6U-rmEJA.png')
          no-repeat center;
        background-size: 100% 100%;
      }

      input {
        width: 100%;
        // color: #ffffff;
        text-indent: 0.47rem;
        padding-right: 0.2rem;
        font-size: 0.35rem;
        background: url('https://img.yzcdn.cn/upload_files/2020/03/18/FvI3N6Oih0iIbryv5rLgi-EM2UZV.png')
          no-repeat;
        background-position: 0.5rem;
        padding-left: 0.69rem;
        background-size: 0.47rem 0.48rem;
      }
    }

    .search-button {
      font-size: 0.4rem;
      font-weight: 400;
      color: #666666;
      position: relative;
      right: 0.3rem;
      top: -0.02rem;
    }
  }

  .search-content {
    &.have__header {
      padding-top: 1.17rem;
    }

    height: 100%;

    .srcollTop {
      width: 1.09rem;
      position: fixed;
      right: 0.56rem;
      bottom: 2.5rem;
    }

    // 初始化页面
    .init_page {
      width: 7.23rem;
      // height: 7.09rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.06);
      border-radius: 0.27rem;
      margin: 0 auto;
      margin-top: 1.19rem;
      padding: 0.53rem 0;

      .init_title {
        text-align: center;
        font-size: 0.4rem;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }

      .init_img {
        margin: 0 auto;
        width: 2.7rem;
        margin-top: 0.29rem;
        margin-bottom: 0.4rem;
      }

      .init_scan {
        width: 2.85rem;
        height: 0.86rem;
        margin: 0 auto;
        background: rgba(255, 255, 255, 1);
        border: 1px solid #ef4246;
        border-radius: 0.11rem;
        font-size: 0.33rem;
        color: #ef4246;
        line-height: 0.8rem;
        text-align: center;
      }
    }

    .searchIndex {
      display: flex;
      padding: 0.3rem;
      border-bottom: solid 1px #f4f4f4;

      .imgWrap {
        width: 2rem;
        flex-shrink: 0;
        margin-right: 0.3rem;

        img {
          display: block;
          width: 100%;
        }
      }

      .search-text {
        display: flex;
        flex-flow: column nowrap;
        text-align: left;

        .title {
          font-size: 0.4rem;
          color: rgba(44, 44, 44, 1);
          margin-bottom: 0.3rem;
          line-height: 1.4;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .des {
          font-size: 0.32rem;
          color: rgba(178, 178, 178, 1);
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }

    .content-end {
      height: 2.74rem;

      p {
        width: 4.8rem;
        margin: 0 auto;
        height: 0.95rem;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(239, 66, 70, 1);
        border-radius: 0.07rem;
        position: relative;
        top: 50%; /*偏移*/
        transform: translateY(-50%);
        font-size: 0.35rem;
        line-height: 0.9rem;
        color: #ef4246;
        text-align: center;

        img {
          display: inline-block;
          width: 0.35rem;
          position: relative;
          top: 0.05rem;
          right: 0.15rem;
        }
      }
    }

    .no-forage {
      margin-top: 2.17rem;
      text-align: center;

      img {
        width: 2.48rem;
        margin: 0 auto;
      }

      p {
        margin: 0 auto;
        font-size: 0.48rem;
        color: #333333;
        margin-top: 0.5rem;
      }

      .no-title {
        font-size: 0.37rem;
        color: #999999;
        margin-top: 0.27rem;
      }

      .make {
        width: 4.29rem;
        margin: 0 auto;
        height: 1.09rem;
        background: rgba(239, 66, 70, 1);
        border-radius: 0.11rem;
        font-size: 0.43rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 1.09rem;
        margin-top: 1.05rem;
      }
    }
  }
}
</style>
